import { AccessCodes } from '@pm2/api';

function makeSearchPageDescriptor(path) {
  return {
    id: "",
    path,
    title: "S\xF8g p\xE5 portal",
    description: void 0,
    accessCode: AccessCodes.ALLOWED,
    type: "SiteSearch",
    megaMenu: {
      hasMegaMenu: false,
      terminateMegaMenu: true,
      showGradeFilters: false,
      displayType: {},
      allFiltersSelectorText: ""
    },
    hasChildren: false,
    hasResources: false,
    clientside: true
  };
}

export { makeSearchPageDescriptor };
//# sourceMappingURL=util.make-search-page-descriptor.js.map
